import { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { mixpanelTrack } from 'utils/app';
import { useHasPermission } from 'utils/hooks';
import { Button } from '@/ui/design-system/components/ui/button';
import SettingsSidebar from './SettingsSidebar';
import General from './General';
import ApiKeys from './ApiKeys';

const sectionTitles = {
    '/settings': 'General',
    '/settings/api': 'API Keys',
};

function Settings() {
    const { pathname } = useLocation();
    const [createOpen, setCreateOpen] = useState(false);
    const { hasPermission: canManageSecretKeys, isReady } = useHasPermission(
        'api.secret_key.manage',
    );

    useEffect(() => {
        mixpanelTrack('Settings');
    }, []);

    const title = sectionTitles[pathname] || 'General';

    return (
        <div className="-mb-16 flex min-h-screen">
            <SettingsSidebar />
            <div className="flex flex-1 flex-col">
                <header className="flex items-center justify-between border-b border-border px-10 pb-4 pt-4">
                    <h1 className="text-lg font-semibold normal-case text-foreground">
                        {title}
                    </h1>
                    {pathname === '/settings/api' && (
                        <Button
                            onClick={() => setCreateOpen(true)}
                            disabled={!isReady || !canManageSecretKeys}
                        >
                            <Plus className="h-4 w-4" />
                            Create new key
                        </Button>
                    )}
                </header>
                <main className="flex-1 px-10 py-8">
                    <div className="mx-auto max-w-[900px]">
                        <Switch>
                            <Route exact path="/settings" component={General} />
                            <Route
                                exact
                                path="/settings/api"
                                render={() => (
                                    <ApiKeys
                                        createOpen={createOpen}
                                        setCreateOpen={setCreateOpen}
                                    />
                                )}
                            />
                            <Redirect to="/settings" />
                        </Switch>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Settings;
